import { Navigate } from 'react-router-dom';
import { useAuth } from '@Contexts/auth';
import { getHomePath } from '@Utils/homeRoute';

/**
 * Landing element for `/`. Signed-out visitors are already on their way to the
 * login screen, so this renders nothing rather than racing that redirect.
 */
const HomeRedirect = () => {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) return null;

  return <Navigate to={getHomePath()} replace />;
};

export default HomeRedirect;
